export class DropDownList {
    id: string;
    itemName: string;
    group?: string;
    industry?: Industry
}

class Industry {
    name?: string;
    sapCode?: string;
    _id?: string;
}



// WEBPACK FOOTER //
// ./src/app/models/DropDownList.model.ts